import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee3a78b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "tags" }




export default /*#__PURE__*/_defineComponent({
  __name: 'RecipePanel',
  props: ['recipe'],
  setup(__props) {

const props = __props



function createSlug(tag: string) {

    // Remove Umlaut/Accents
    tag = tag.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // Replace spaces with dashes
    tag = tag.replace(/\s+/g, '-')

    return '/tag/' + tag.toLowerCase();

}

function formatTime(time: number) {

    if (time < 60) {
        return time + 'm';
    }

    else {
        const hours = Math.floor(time / 60);
        const minutes = time % 60;

        if (minutes == 0) {
            return hours + 'h';
        } else {
            return hours + 'h' + minutes + 'm';
        } 
    }

}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "link",
    to: '/recipe/' + props.recipe.slug
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: props.recipe.img,
            alt: props.recipe.title
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(formatTime(props.recipe.time)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(props.recipe.title), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.recipe.tags, (tag) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "tag",
                  key: tag
                }, [
                  _createVNode(_component_router_link, {
                    to: createSlug(tag)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})